<template>
  <base-card>
    <BaseCardTitle>
      <img
        src="/img/icon-cart.svg"
        alt
      >
      Activity
    </BaseCardTitle>
    <div
      v-for="(contact, index) in activity"
      :key="index"
      :class="{'ml-5': isEqualToPrev(index, contact.outreach.edit.pk )}"
    >
      <hr v-if="isEqualToPrev(index, contact.outreach.edit.pk )">
      <hr
        v-if="!isEqualToPrev(index, contact.outreach.edit.pk )"
        style="border-top: solid 1px black"
      >

      <div class="d-flex justify-content-between mb-1">
        <div class="d-flex justify-content-between align-items-center">
          <!-- <div class="mr-2" v-if="isEqualToPrev(index, contact.outreach.edit.pk )">
                        <font-awesome-icon icon="caret-right" />
                    </div> -->
          <div>
            <div>
              <small
                v-if="contact.last"
                class="text-muted"
              >{{ $moment(contact.last * 1000).format(dateformat) }} Opens: {{ contact.opens }} | Clicks: {{ contact.clicks }}</small>
              <small
                v-else
                class="text-muted"
              >No events yet</small>
              <br>
              <strong>
                <span v-html="contact.outreach.edit.subject.replace(/(<([^>]+)>)/ig,'')" />
              </strong>
            </div>
            <div class="mt--1">
              <span class="mr-2 text-muted">
                {{ contact.customer.first_name }} {{ contact.customer.last_name }}
                <small>({{ contact.customer.email }})</small>
              </span>
            </div>

            <div>
              <div
                v-for="entry in contact.clicked_products"
                :key="entry.pk"
                class="mr-1 my-2 d-inline-block text-center"
              >
                <img
                  v-b-tooltip.hover
                  class="mb-2"
                  :class="`${entry.site_url && entry.site_url.length > 0 ? 'clickable' : ''}`"
                  :src="entry.thumb"
                  alt
                  :title="entry.title"
                  width="80"
                  @click="openInNewTab(entry.site_url)"
                >
              </div>
            </div>
          </div>
        </div>
        <div style="mr-0">
          <img
            v-if="contact.outreach.edit.hero && !isEqualToPrev(index, contact.outreach.edit.pk )"
            height="130"
            :src="contact.outreach.edit.hero"
          >
        </div>
      </div>
    </div>

    <ButtonMore
      v-if="loading || $store.state.activity.next"
      :loading="loading"
      @click="loadMore"
    />
  </base-card>
</template>

<script>
export default {
  name: 'StylistActivityClick',
  props: {
    scope: {
      default: 'stylist',
    },
    stylist: Number,
  },
  data() {
    return {
      currentContactCell: {},
    };
  },
  computed: {
    activity() {
      return this.$store.state.activity.items;
    },
    loading() {
      return this.$store.state.activity.loading;
    },
  },
  mounted() {
    // const args = {};
    if (this.stylist) {
      this.$store.dispatch('activity/activityForSylist', this.stylist);
    } else {
      this.$store.dispatch('activity/fetchData', { scope: 'stylist' });
    }
  },
  methods: {
    isEqualToPrev(index, editPK) {
      if (this.activity[index - 1]) {
        if (this.activity[index - 1].outreach.edit.pk === editPK) {
          return true;
        }
      }

      return false;
    },
    loadMore() {
      this.$store.dispatch('activity/fetchMoreData');
    },
  },
};
</script>

<style scoped>
.clickable {
    cursor: pointer;
    opacity: 1;
    transition: opacity .3s ease;
}
.clickable:hover {
    opacity: 0.7;
}
</style>
